import React, { Fragment } from "react";
import _isArray from "lodash-es/isArray";
import _isEmpty from "lodash-es/isEmpty";
import { MenuHoc, TranslateHoc } from "../../../../../../assets/images";
import {
  downloadMediaFile,
  getDisplayNameFromGroup,
  isSingleChat,
  isTextMessage,
  getMsgStatusEle,
  uploadFileToSDK,
  getMessageFromHistoryById,
  offlineReplyHandle
} from "../../../../../../Helpers/Chat/ChatHelper";
import {
  getMediaClassName,
  getThumbBase64URL,
  blockOfflineAction,
  isAppOnline,
  isCallLink,
  getDbInstanceName,
  getConversationHistoryTime,
  getColorCodeInitials,
  getInitialsFromName,
  getColorBgCodeInitials
} from "../../../../../../Helpers/Utility";
import ForwardMessage from "../Common/ForwardMessage.js";
import ReplyMessageBlock from "../Common/ReplyMessage.js";
import { getMessageTimeElement } from "../../../../../../Helpers/UIElements.js";
import { formatUserIdToJid } from "../../../../../../Helpers/Chat/User";
import CommonChatStatus from "./CommonChatStatus";
import ForwardCommon from "./ForwardCommon";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../../../Common/Modal";
import { ContactPopup } from "../../../PopUp/ContactPopup.js";
import DropDownAction from "../Common/DropDownAction";
import ImageComponent from "./ImageComponent";
import VideoComponent from "./VideoComponent";
import IndexedDb from "../../../../../../Helpers/IndexedDb";
import AudioComponent from "./AudioComponent";
import DocumentComponent from "./DocumentComponent";
import LocationComponent from "./LocationComponent";
import ContactComponent from "./ContactComponent";
import { singleChatSelectedMedia } from "../../../../../../Redux/feature/singleChatSelectedMediaSlice";
import { store } from "../../../../../../Redux/store";
import { addForwardMessageData } from "../../../../../../Redux/feature/forwardMessageDataSlice";
import SDK from "../../../../../../SDK";
import { getFromLocalStorageAndDecrypt } from "../../../../../../Helpers/Chat/webChatEncryptDecrypt";
import { toast } from "react-toastify";
import TextComponentOTF from "./TextComponentOTF";

const ChatMessageTemplate = (props = {}) => {
  const otfHidden = false;
  const dispatch = useDispatch();
  const webLocalStorageSetting = useSelector((state) => state.webLocalStorageSetting);
  const { isTranslationEnabled = false } = useSelector((state) => state.featureFlagList.data);
  let isEnableTranslate = false;
  if (isTranslationEnabled) {
    isEnableTranslate = webLocalStorageSetting.isEnableTranslate || false;
  }
  const {
    jid,
    messageAction,
    messageObject = {},
    vCardData = {},
    messageContent = {},
    viewOriginalMessage,
    messageInfoOptions,
    requestReplyMessage,
    addionalnfo = {},
    chatType,
    groupMemberDetails,
    message_type,
    closeMessageOption,
    pageType,
    handleTranslateLanguage
  } = props;
  const singleChat = isSingleChat(chatType);
  const {
    fromUserId,
    createdAt,
    msgStatus,
    msgId,
    deleteStatus,
    publisherId,
    timestamp,
    favouriteStatus,
    previousMessageUser,
    msgBody: { contact = {} } = {}
  } = messageObject;
  const { name = "", phone_number = "" } = contact || {};
  const messageText = messageObject?.msgBody?.message;
  let messageFrom = singleChat ? fromUserId : publisherId;
  const { forward = false, forwardMessageId } = addionalnfo;
  const { fromUser } = vCardData;
  const isSender = messageFrom && messageFrom.indexOf(fromUser) === -1;
  // For GroupChat
  const isSameUser = messageFrom !== previousMessageUser;
  const { nameToDisplay = "", userColor = "" } = singleChat
    ? {}
    : getDisplayNameFromGroup(messageFrom, groupMemberDetails);
  const style = { color: userColor };
  const { replyTo, media = {} } = messageContent;
  const { file, caption, thumb_image, file_url, is_uploading, webWidth, fileName, file_key } = media || {};
  const [isChecked, selectedToForward] = React.useState(false);
  const [dropDownStatus, setDropDown] = React.useState(false);
  const [uploadStatus, setUploadStatus] = React.useState(4);
  const [isSubscribed, setIsSubscribed] = React.useState(true);
  const thumbURL = thumb_image ? getThumbBase64URL(thumb_image) : "";
  const [imgSrc, saveImage] = React.useState(thumbURL);
  const [popUpStatus, setPopUpStatus] = React.useState(false);
  const [mediaUrl, setMediaUrl] = React.useState("");
  const [popupStatus, setPopupStatus] = React.useState(false);
  const [dropRight, setDropRight] = React.useState(false);

  const messageStatus = getMsgStatusEle(msgStatus, messageFrom);
  const localDb = React.useMemo(() => new IndexedDb(), []);

  const isTranslatable = () => {
    const { msgBody: { translatedMessage = "", message = "", media: mediMsg = {} } = {} } = messageObject;
    const { caption: captionText = "" } = mediMsg || {};
    return !translatedMessage && (message || captionText);
  };

  const imgFileDownload = async () => {
    localDb
      .getImageByKey(file_url, getDbInstanceName("image"), file_key)
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        if (isSubscribed) {
          setUploadStatus(2);
          saveImage(blobUrl);
        }
      })
      .catch(() => {
        if (isSender) {
          //is sender side only status upload 6
          setUploadStatus(6);
        }
        if (isSubscribed) saveImage(getThumbBase64URL(thumb_image));
      });
  };

  React.useEffect(() => {
    if (is_uploading === 0 || is_uploading === 1) {
      setUploadStatus(is_uploading);
      if (isImageMessage()) saveImage(file_url);
      if (isAudioMessage()) setMediaUrl(file_url);
    } else if (is_uploading === 3 || is_uploading === 7) {
      if (isImageMessage()) saveImage(file_url);
    } else if (is_uploading !== 0 && is_uploading !== 8) {
      if (isImageMessage()) imgFileDownload();
      else if (isAudioMessage()) getAudioFile();
      else setUploadStatus(2);
    }
    return () => setIsSubscribed(false);
  }, []);

  const handleDropDown = (event) => {
    event.stopPropagation();
    setDropDown(!dropDownStatus);
    setDropRight(isTextMessage(message_type) && messageText.length <= 13 ? true : false);
  };

  const closeDropDown = () => {
    setDropDown(false);
  };

  const sentMessageToParent = (event) => {
    setDropDown(!dropDownStatus);
    messageAction(event, messageObject);
  };

  const selectMessage = (checked) => {
    selectedToForward(checked);
  };

  const imgFileDownloadOnclick = (event = {}) => {
    console.log("imgFileDownloadOnclick--CLicked")
  };

  const handleMediaShow = (e) => {
    if (uploadStatus !== 2) {
      return true;
    }
    if (document && document.getElementById("imagePreviewContainer")) {
      document.getElementById("imagePreviewContainer").querySelectorAll("video, audio").forEach((element) => element.pause());
    }
    const data = { jid: props.jid, chatType: props.chatType, selectedMessageData: messageObject };
    store.dispatch(singleChatSelectedMedia(data));
    return false;
  };

  React.useEffect(() => {
    msgStatus === 0 && setUploadStatus(2);
  }, [msgStatus]);

  const handleDropDownVideo = (event) => {
    event.stopPropagation();
    setDropDown(!dropDownStatus);
  };

  const showForwardPopUp = () => {
    const recordingStatus = getFromLocalStorageAndDecrypt("recordingStatus");
    if (!recordingStatus) {
      toast.error("You are on Audio Recording ")
      return
    }
    if (!isAppOnline()) {
      blockOfflineAction();
      return;
    }
    dispatch(addForwardMessageData({ msgId, timestamp, favouriteStatus }));
    setPopUpStatus(true);
  };

  const closeForwardPopUp = () => {
    closeMessageOption(true);
    setPopUpStatus(false);
  };

  const updatePhone = _isArray(phone_number) ? phone_number.join("\n") : phone_number;

  React.useEffect(() => {
    if (replyTo) {
      const newObj = getMessageFromHistoryById(jid, replyTo);
      if (_isEmpty(newObj)) {
        requestReplyMessage(msgId, replyTo, chatType);
      } else {
        offlineReplyHandle(newObj, replyTo);
      }
    }
  }, [])

  React.useEffect(() => {
    if (mediaUrl === "" && file_url !== "" && is_uploading === 8) getAudioFile();
  }, [file_url]);

  const getAudioFile = async () => {
    await SDK.getMediaURL(file_url, file_key).then((blob) => {
      const blobUrl = window.URL.createObjectURL(blob?.data.blob);
      setMediaUrl(blobUrl);
      setUploadStatus(2);
    }).catch(() => {
      setMediaUrl(null);
      if (isSender) {
        //is sender side only status upload 6
        setUploadStatus(6);
      }
    });
  };

  React.useEffect(() => {
    if (pageType === "msgInfo") {
      if (isImageMessage()) {
        imgFileDownload();
      } else if (isAudioMessage()) {
        getAudioFile();
      } else if (isVideoMessage()) {
        saveImage(thumbURL);
      }
    }
  }, [msgId]);

  React.useEffect(() => {
    is_uploading === 8 && setUploadStatus(is_uploading);
    if (is_uploading === 1 || is_uploading === 20) {
      setUploadStatus(1);
      setTimeout(() => {
        uploadFileToSDK(file, formatUserIdToJid(jid, chatType), msgId, props.messageContent.media);
      })
    }
    (is_uploading === 3 || is_uploading === 7) && setUploadStatus(3);
  }, [is_uploading]);

  const downloadAction = async (event) => {
    if (uploadStatus !== 2) return;
    downloadMediaFile(file_url, "file", fileName, file_key, event);
  };

  const toggleContactPopup = () => {
    setPopupStatus(!popupStatus);
  };

  const isImageMessage = () => message_type === "image";
  const isVideoMessage = () => message_type === "video";
  const isAudioMessage = () => message_type === "audio";
  const isLocationMessage = () => message_type === "location";
  const isDocumentMessage = () => message_type === "file";
  const isContactMessage = () => message_type === "contact";

  const replyTextClass = singleChat && isTextMessage(message_type) ? " reply-text" : " sender-text-group";

  const getMessageElementRootClass = () =>
    `${isSender ? " sender" : " receiver"}${isImageMessage() && caption === "" ? " singleFile" : ""}${isImageMessage() || isVideoMessage() ? " image-block" : ""
    }${replyTo ? " reply-block" : ""}${isTextMessage(message_type) ? replyTextClass : ""}${isAudioMessage() ? " audio-message" : ""
    }${uploadStatus === 2 ? "" : " fileProgress"}${isLocationMessage() ? " location-message image-block singleFile" : ""
    }${isDocumentMessage() ? " file-message" : ""}${isContactMessage() ? " contact-message" : ""}`;

  return (
    <Fragment>
      <div className={`otf_bubble_1 ${isSender ? "receiverchat" : "senderchat"}`}>
        <div className="left">
          <div style={{ backgroundColor: !isSender ? "#D3E6FF" : getColorBgCodeInitials(getColorCodeInitials(nameToDisplay)) }} className="profile_picture">
            {!isSender ? (
              <span style={{ color: "#0A7BFD" }} >{getInitialsFromName(nameToDisplay || "You")}</span>
            ) : (
              <span style={{ color: getColorCodeInitials(nameToDisplay) }} >{getInitialsFromName(nameToDisplay)}</span>
            )}
          </div>
        </div>
        <div className="right">
          <div className="sender_wraper">
            <strong title={nameToDisplay} className="sender_name">{nameToDisplay}</strong>
            <span className="sender_time">{getConversationHistoryTime(createdAt)}</span>
          </div>

          <div
            id={msgId}
            className={`${getMediaClassName(dropDownStatus, isSender, forward, msgStatus, isChecked)}${isVideoMessage() && caption === "" ? "singleFile" : ""
              }${isVideoMessage() && caption !== "" ? " has-caption " : ""}${isImageMessage() && caption !== "" ? " has-caption " : ""
              }${isAudioMessage() && isSingleChat(chatType) ? " singleChat" : " groupChat"}${dropRight ? " drop-right" : " "
              }`}
            data-msg-type={message_type}
          >
            <ForwardMessage
              msgid={msgId}
              forwardMessageId={forwardMessageId}
              forward={forward}
              timestamp={timestamp}
              favouriteStatus={favouriteStatus}
              selectedToForward={selectMessage}
            />

            <div
              style={{ width: isImageMessage() || isVideoMessage() ? webWidth : "" }}
              className={`${getMessageElementRootClass()} ${isTextMessage(message_type) && isCallLink(messageText) ? "meetinglink" : ""
                }`}
            >
              {otfHidden && isSameUser && isSender && nameToDisplay && (
                <span title={nameToDisplay} className="sender-name" style={style}>
                  {nameToDisplay}
                </span>
              )}

              {replyTo && (
                <ReplyMessageBlock
                  viewOriginalMessage={viewOriginalMessage}
                  msgId={replyTo}
                  chatType={chatType}
                  groupMemberDetails={groupMemberDetails}
                />
              )}

              {isTextMessage(message_type) && (
                <TextComponentOTF
                  messageObject={messageObject}
                  pageType={pageType}
                  handleShowCallScreen={props.handleShowCallScreen}
                />
              )}

              {isImageMessage() && (
                <ImageComponent
                  messageObject={messageObject}
                  imgSrc={imgSrc}
                  fileKey={file_key}
                  handleMediaShow={handleMediaShow}
                  isSender={isSender}
                  uploadStatus={uploadStatus}
                  imgFileDownloadOnclick={imgFileDownloadOnclick}
                  pageType={pageType}
                />
              )}

              {isVideoMessage() && (
                <VideoComponent
                  messageObject={messageObject}
                  fileKey={file_key}
                  handleMediaShow={handleMediaShow}
                  thumbURL={thumbURL}
                  isSender={isSender}
                  uploadStatus={uploadStatus}
                  imgFileDownloadOnclick={imgFileDownloadOnclick}
                  pageType={pageType}
                />
              )}

              {isAudioMessage() && (
                <AudioComponent
                  mediaUrl={mediaUrl}
                  fileKey={file_key}
                  messageObject={messageObject}
                  isSender={isSender}
                  uploadStatus={uploadStatus}
                // audioFileDownloadOnclick={audioFileDownloadOnclick}
                />
              )}

              {isLocationMessage() && <LocationComponent messageObject={messageObject} />}

              {isDocumentMessage() && (
                <DocumentComponent
                  messageObject={messageObject}
                  fileKey={file_key}
                  isSender={isSender}
                  uploadStatus={uploadStatus}
                  downloadAction={downloadAction}
                />
              )}

              {isContactMessage() && (
                <ContactComponent
                  messageObject={messageObject}
                  isSender={isSender}
                  uploadStatus={uploadStatus}
                  toggleContactPopup={toggleContactPopup}
                />
              )}

              {otfHidden ? getMessageTimeElement(messageStatus, createdAt, favouriteStatus, isSender, message_type, fromUserId === fromUser) : null}

              {!isTextMessage(message_type) && (
                <Fragment>
                  <CommonChatStatus
                    msgId={msgId}
                    chatType={chatType}
                    forward={forward}
                    isSender={isSender}
                    favouriteStatus={favouriteStatus}
                    uploadStatus={uploadStatus}
                    dropDownStatus={dropDownStatus}
                    handleDropDown={handleDropDownVideo}
                    isSingleChat={isSingleChat(chatType)}
                    messageInfoOptions={messageInfoOptions}
                    msgType={message_type}
                    sentMessageToParent={sentMessageToParent}
                    pageType={pageType}
                    messageObject={messageObject}
                    handleTranslateLanguage={handleTranslateLanguage}
                    isEnableTranslate={isEnableTranslate}
                    caption={caption}
                    isTranslatable={isTranslatable()}
                  />
                  <ForwardCommon
                    jid={jid}
                    pageType={pageType}
                    forward={forward}
                    popUpStatus={popUpStatus}
                    uploadStatus={uploadStatus}
                    showForwardPopUp={showForwardPopUp}
                    closeForwardPopUp={closeForwardPopUp}
                  />
                </Fragment>
              )}

              {!forward && isTextMessage(message_type) && pageType === "conversation" && (
                <div className={`${isTranslatable() && isEnableTranslate ? "drop-lg" : ""} message-dropdown-menu`}>
                  <span className="message-dropdown">
                    {isEnableTranslate && isTranslatable() && isSender && (
                      <span onClick={() => handleTranslateLanguage(msgId, messageObject)} className="translateIcon">
                        {" "}
                        <TranslateHoc viewBox="0 0 25 25" />
                      </span>
                    )}
                    <span className="actionDrop" onClick={handleDropDown}></span>
                    <i>
                      <MenuHoc viewBox="0 0 11.926 6.566" />
                    </i>
                  </span>
                  {dropDownStatus && deleteStatus === 0 && (
                    <DropDownAction
                      messageObject={messageObject}
                      chatType={chatType}
                      messageInfoOptions={messageInfoOptions}
                      msgid={msgId}
                      closeDropDown={closeDropDown}
                      handleDropDown={handleDropDown}
                      isSender={isSender}
                      messageAction={sentMessageToParent}
                      msgType={message_type}
                      favouriteStatus={favouriteStatus}
                    />
                  )}
                </div>
              )}
            </div>

            {popupStatus && (
              <Modal containerId="container">
                <ContactPopup toggleContactPopup={toggleContactPopup} name={name} phoneNumber={updatePhone} />
              </Modal>
            )}
          </div>
        </div>
        {/* {nameToDisplay && (
          <div style={{ marginTop: (isSameUser && isSender && nameToDisplay) ? "8px" : "4px" }} className={`otf_chat_bubble ${isSender ? " _sender " : " _receiver "}`}>
            {isSameUser && isSender && nameToDisplay ? <span className="sender-name" style={style}>
              {nameToDisplay}
            </span> : null}

            {isSameUser && !isSender ? <span className="sender-name" style={style}>
              You
            </span> : null}
            {getMessageTimeElement(messageStatus, createdAt, favouriteStatus, isSender, message_type, fromUserId === fromUser, otfHidden)}
          </div>
        )} */}
      </div>
    </Fragment>
  );
};

export default ChatMessageTemplate;
